// Tilastot seinällä (statistics_view.v1): the `statisticsView` namespace, in its own
// file so the module's strings grow here, not in fi.js / en.js / sv.js.
// specs/workshop-modules/statistics_view.md

export const statisticsViewFi = {
  title: 'Tilastot',
  wallTitle: 'Tilastot seinällä',
  loading: 'Ladataan…',
  loadError: 'Tilastojen lataus epäonnistui: {{message}}',
  noInstance: 'Työpajaa ei ole valittu: avaa sivu työpajan linkistä (?kid=…).',
  noTables: 'Työpajan tietoaineistossa ei ole tilastotauluja. Lisää tilastoaineisto Aineistot → Tietopohjat -sivulla ja liitä se työpajaan.',
  noChoice: 'Fasilitaattori ei ole vielä valinnut seinälle taulua.',
  table: 'Taulu',
  chart: 'Kuvaaja',
  chartLine: 'Viiva ajassa',
  chartBars: 'Pylväät yhdeltä jaksolta',
  period: 'Jakso',
  spread: 'Sarjoiksi',
  fixed: 'Kiinnitä',
  spreadHint: 'Enintään kaksi ulottuvuutta sarjoiksi; muut kiinnitetään yhteen arvoon.',
  unit: 'Yksikkö: {{unit}}',
  source: 'Lähde: {{source}}',
  licence: 'Lisenssi: {{licence}}',
  openSource: 'Avaa lähde',
  truncated: 'Näytetään {{shown}} / {{total}} sarjaa.',
  missing: 'Puuttuva arvo',
  values: 'Arvot taulukkona',
  showOnWall: 'Näytä seinällä',
  shownOnWall: 'Seinällä nyt: {{title}}',
  saveFailed: 'Valintaa ei tallennettu: {{message}}',
  admin: {
    title: 'Tilastot seinällä',
    lead: 'Valitse taulu ja leikkaus. Seinä ja iPadit näyttävät saman kuvaajan lähteineen.',
    dataset: 'Tietoaineisto: {{name}}',
    rows: '{{count}} havaintoa',
  },
};

export const statisticsViewEn = {
  title: 'Statistics',
  wallTitle: 'Statistics on the wall',
  loading: 'Loading…',
  loadError: 'Loading the statistics failed: {{message}}',
  noInstance: 'No workshop selected: open the page from the workshop link (?kid=…).',
  noTables: 'The workshop\'s dataset has no statistical tables. Add a statistics dataset under Datasets → Knowledge bases and attach it to the workshop.',
  noChoice: 'The facilitator has not chosen a table for the wall yet.',
  table: 'Table',
  chart: 'Chart',
  chartLine: 'Line over time',
  chartBars: 'Bars for one period',
  period: 'Period',
  spread: 'As series',
  fixed: 'Fix to',
  spreadHint: 'At most two dimensions as series; the rest are fixed to one value.',
  unit: 'Unit: {{unit}}',
  source: 'Source: {{source}}',
  licence: 'Licence: {{licence}}',
  openSource: 'Open the source',
  truncated: 'Showing {{shown}} of {{total}} series.',
  missing: 'Missing value',
  values: 'Values as a table',
  showOnWall: 'Show on the wall',
  shownOnWall: 'On the wall now: {{title}}',
  saveFailed: 'The choice was not saved: {{message}}',
  admin: {
    title: 'Statistics on the wall',
    lead: 'Pick the table and the slice. The wall and the iPads show the same chart with its source.',
    dataset: 'Dataset: {{name}}',
    rows: '{{count}} observations',
  },
};

export const statisticsViewSv = {
  title: 'Statistik',
  wallTitle: 'Statistik på väggen',
  loading: 'Laddar…',
  loadError: 'Statistiken kunde inte laddas: {{message}}',
  noInstance: 'Ingen verkstad vald: öppna sidan från verkstadens länk (?kid=…).',
  noTables: 'Verkstadens datamaterial har inga statistiktabeller. Lägg till ett statistikmaterial under Material → Kunskapsbaser och koppla det till verkstaden.',
  noChoice: 'Facilitatorn har inte valt någon tabell för väggen ännu.',
  table: 'Tabell',
  chart: 'Diagram',
  chartLine: 'Linje över tid',
  chartBars: 'Staplar för en period',
  period: 'Period',
  spread: 'Som serier',
  fixed: 'Fäst vid',
  spreadHint: 'Högst två dimensioner som serier; resten fästs vid ett värde.',
  unit: 'Enhet: {{unit}}',
  source: 'Källa: {{source}}',
  licence: 'Licens: {{licence}}',
  openSource: 'Öppna källan',
  truncated: 'Visar {{shown}} av {{total}} serier.',
  missing: 'Saknat värde',
  values: 'Värden som tabell',
  showOnWall: 'Visa på väggen',
  shownOnWall: 'På väggen nu: {{title}}',
  saveFailed: 'Valet sparades inte: {{message}}',
  admin: {
    title: 'Statistik på väggen',
    lead: 'Välj tabell och snitt. Väggen och iPadarna visar samma diagram med sin källa.',
    dataset: 'Datamaterial: {{name}}',
    rows: '{{count}} observationer',
  },
};
